export const getConfigValue = (value = 0) => parseFloat(value) || 0

export const getPercent = (val = 0) => val * 100 + '%'

/**
 * 计算 winning tax
 * @param {Number} winningAmount 预计获得的金额
 * @param {Number} stake
 * @param {Number} taxA config tax a
 * @param {Number} taxB config tax a
 * @returns {Number}
 */
export const calcWinningTax = ({ winningAmount, stake, taxA, taxB }) => {
  if (!stake || !winningAmount || !taxA) return 0
  const winningTax = winningAmount * taxA - stake * taxA * taxB
  // console.log(`DEBUG: winningTax ${winningTax} = ${winningAmount} * ${taxA} - ${stake} * ${taxA} * ${taxB}`)
  return winningTax > 0 ? winningTax : 0
}

/**
 * 计算 tax 补偿 bonus
 * @param {Number} winningAmount 预计获得的金额
 * @param {Number} stake
 * @param {Number} taxA config tax a
 * @param {Number} taxB config tax a
 * @param {Number} stakeRatio  使用 voucher 后实际支付比例, 默认为 1
 * @returns {Number}
 */
export const calcTaxBonus = ({ winningAmount, stake, taxA, taxB, stakeRatio = 1 }) => {
  if (!stake || !winningAmount || !taxA) return 0
  const extraBonus = (winningAmount * taxA - stake * taxA * taxB) * stakeRatio
  // console.log(`DEBUG: extraBonus ${extraBonus} = (${winningAmount} * ${taxA} - ${stake} * ${taxA} * ${taxB}) * ${stakeRatio}`)
  return extraBonus > 0 ? extraBonus : 0
}
